import mifidApi from '../../api/mifid2-treasury-api';
const MIFID_FAILED = 'mifid_failed'; // hiba
const MIFID_GET_MASTER_DATA = 'mifid2_treasury_get_master_data'; // törzsadat lekérdezés
const MIFID_CALCULATE = 'mifid2_treasury_calculate'; // számolj!
const MIFID_SET_CALCULATED = 'mifid_set_calculated'; // az eredmény az pariban van-e a kiválasztott értékekkel
const MIFID_SET_LOADING = 'mifid_set_loading'; // pörgettyű vizualizáció trigger

const mifidTreasuryState = {
	defaultUgyfelTipus: 'TKU',
	ugyfelTipusok: [],
	piac: '',
	szolgaltatasok: [],
	otpUgyfelTipusok: [],
	result: {},
	calculated: false,
	loading: false,
	masterDataLoaded: false,
	downloadResult: null
};
function onError(commit) {
	return function (error) {
		commit(MIFID_SET_LOADING, false);
		commit(MIFID_FAILED, error);
	};
}
const mifidTreasuryActions = {
	clearCalculated({ commit }) {
		commit(MIFID_SET_CALCULATED, false);
	},
	/* init({commit}) {
		commit(MIFID_SET_CALCULATED, false);
		commit(MIFID_SET_LOADING, true);
		mifidApi.init().then(possibleValues=> {
			commit(MIFID_SET_LOADING, false);
			commit(MIFID_GET_MASTER_DATA, possibleValues.data);
		}).catch(onError);
	},*/
	getMasterData({ commit }, masterDataParams) {
		commit(MIFID_SET_CALCULATED, false);
		commit(MIFID_SET_LOADING, true);
		mifidApi
			.getMasterData(masterDataParams)
			.then((possibleValues) => {
				commit(MIFID_SET_LOADING, false);
				commit(MIFID_GET_MASTER_DATA, possibleValues.data);
			})
			.catch(onError);
	},
	calculate({ commit }, selectedValues) {
		commit(MIFID_SET_LOADING, true);
		mifidApi
			.calculate(selectedValues)
			.then((result) => {
				commit(MIFID_SET_LOADING, false);
				commit(MIFID_CALCULATE, result.data);
				commit(MIFID_SET_CALCULATED, true);
			})
			.catch(onError);
	}
};
const mifidTreasuryMutations = {
	[MIFID_FAILED](state, error) {
		console.error(error);
	},
	[MIFID_GET_MASTER_DATA](state, possibleValues) {
		state.ugyfelTipusok = possibleValues.ugyfelTipusok;
		state.piac = possibleValues.piac;
		state.otpUgyfelTipusok = possibleValues.otpUgyfelTipusok;
		state.szolgaltatasok = possibleValues.szolgaltatasok;
		state.masterDataLoaded = true;
	},
	[MIFID_CALCULATE](state, result) {
		state.result = Object.assign({}, state.result, result);
	},
	[MIFID_SET_CALCULATED](state, data) {
		state.calculated = data;
	},
	[MIFID_SET_LOADING](state, data) {
		state.loading = data;
	}
};

export default {
	namespaced: true,
	state: mifidTreasuryState,
	mutations: mifidTreasuryMutations,
	actions: mifidTreasuryActions
};
